import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from '../../icon-button';

import Icon from '../assets/rightChevron.svg?react';

const Container = styled.div`
    display: flex;
    background-color: ${(props) => props.theme.colors['surface-white']};
    padding-left: 16px;
    box-shadow: ${(props) => props.theme.shadows['shadow-02dp']};
    border-radius: 4px;
`;

export const Header = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    padding: 4px 8px;
    cursor: pointer;
`;

const HeaderContent = styled.div`
    flex-grow: 1;
    align-self: center;
`;

const TheryButton = ({ children, onClick }) => {
    return (
        <Container onClick={onClick}>
            <Header>
                <HeaderContent>{children}</HeaderContent>
                <IconButton type="tertiary" size="xsmall">
                    <Icon />
                </IconButton>
            </Header>
        </Container>
    );
};

TheryButton.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func,
};

export default TheryButton;
